module.exports = {"title":"Management","navigationLinks":[{"title":"Box Office","url":"/events","subLinks":[]},{"title":"Customers","url":"#","subLinks":[{"title":"Search/Edit","url":"/search"},{"title":"Add","url":"/create-customer"}]},{"title":"My Profile","url":"/my-profile","subLinks":[]},{"title":"Purchase equipment","url":"https://equipment.showtix4u.com","external":true,"subLinks":[]},{"title":"FAQ","url":"/faq","subLinks":[]},{"title":"Logout","url":"/logout","subLinks":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/AdminNavigation/locales/fr.json
// module id = 808
// module chunks = 0